<div class="row">
  <div class="card shadow-none rounded">
    <div class="card-body">
      <div class="col-12 col-md-12 col-xxl-12 col-xl-12">
        <div class="row">
          <div class="col-12 col-xxl-10 col-xl-10 col-md-10 col-lg-10 col-sm-8">
            <h4 class="fw-bold">
              Loans and other debts due to members - Small Limited Liability Partnership (FRS 102)
            </h4>
          </div>
          <div class="col-12 col-xxl-2 col-xl-2 col-md-2 col-lg-2 col-sm-4 text-start text-sm-end p-sm-0 pt-2">
            <button type="button" class="btn btn-outline-themecolorlight" style="padding: 7px;font-weight: 600; font-size: 14px;" (click)="TotalBack()" tabindex="-1">Close Accounts</button>
          </div>
        </div>
      </div>
      <hr />
      <div class="col-12 col-md-12 col-xxl-12 col-xl-12 col-lg-12  col-sm-12">
        <div class="row">
          <div class="col-12">
            <!--<h5 class="fw-bolder font-size-16">
              Loans and other debts due to debtors
            </h5>-->
            <p class="text-dark">Please enter notes on debtors.</p>
            <p class="text-dark">If you do not have any notes to make, please return to the notes menu and de-select this section.</p>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-xxl-11 col-xl-12 col-md-12 col-lg-12 col-sm-12 mt-3">
            <form [formGroup]="LoansandotherdebsFormGroup">
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <div class="row">
                      <div class="col-xxl-4 col-xl-4 col-md-12 col-lg-12 col-sm-12 col-12">
                        <h6 class="m-t-5 fw-bolder"></h6>
                      </div>
                      <div class="col-xxl-8 col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div class="row">
                          <div [ngClass]="commonService.showControl? 'col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6':'col-xxl-9 col-xl-10 col-lg-10 col-md-11 col-sm-12 col-12'">
                            <div class="mb-2 text-center">
                              <h6 class="mb-0 fw-bolder">{{commonService.StartYear}}</h6>
                              <label>({{commonService.CAPeriodFrom}} to {{commonService.CAPeriodTo}})</label>
                            </div>
                          </div>
                          <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6" *ngIf="commonService.showControl==true">
                            <div class="mb-2 text-center">
                              <h6 class="mb-0 fw-bolder">{{commonService.LastYear}}</h6>
                              <label>({{commonService.StartdateLastAP}} to {{commonService.LYAccountingPeriod}})</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 ps-5">
                  <div class="form-group">
                    <div class="row">
                      <div class="col-xxl-4 col-xl-4 col-md-12 col-lg-12 col-sm-12 col-12">
                        <label class="m-t-5 font-weight-600">Members capital classified as a liability</label>
                      </div>
                      <div class="col-xxl-8 col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div class="row">
                          <div [ngClass]="commonService.showControl? 'col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6':'col-xxl-9 col-xl-10 col-lg-10 col-md-11 col-sm-12 col-12'">
                            <div class="input-group mb-3">
                              <div class="input-group-text">
                                <span class=" theme-color font-weight-600">£</span>
                              </div>
                              <input type="text" class="form-control text-end AccountNumber" [appTooltip]="showBubbledata" appNumberdirective placeholder="" formControlName="NetDebtFunds" (blur)="Calculations()" />
                            </div>
                          </div>
                          <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6" *ngIf="commonService.showControl==true">
                            <div class="input-group mb-3">
                              <div class="input-group-text">
                                <span class=" theme-color font-weight-600">£</span>
                              </div>
                              <input type="text" class="form-control text-end AccountNumber" [appTooltip]="showBubbledata" appNumberdirective placeholder="" formControlName="NetDebtFunds_LY" (blur)="Calculations()" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="row">
                      <div class="col-xxl-4 col-xl-4 col-md-12 col-lg-12 col-sm-12 col-12">
                        <label class="m-t-5 font-weight-600">Loans from members</label>
                      </div>
                      <div class="col-xxl-8 col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div class="row">
                          <div [ngClass]="commonService.showControl? 'col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6':'col-xxl-9 col-xl-10 col-lg-10 col-md-11 col-sm-12 col-12'">
                            <div class="input-group mb-3">
                              <div class="input-group-text">
                                <span class=" theme-color font-weight-600">£</span>
                              </div>
                              <input type="text" class="form-control text-end AccountNumber" [appTooltip]="showBubbledata" appNumberdirective placeholder="" formControlName="LoansFromDirectors" (blur)="Calculations()" />
                            </div>
                          </div>
                          <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6" *ngIf="commonService.showControl==true">
                            <div class="input-group mb-3">
                              <div class="input-group-text">
                                <span class=" theme-color font-weight-600">£</span>
                              </div>
                              <input type="text" class="form-control text-end AccountNumber" [appTooltip]="showBubbledata" appNumberdirective placeholder="" formControlName="LoansFromDirectors_LY" (blur)="Calculations()" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                      <div class="form-group">
                        <div class="row">
                          <div class="col-xxl-4 col-xl-4 col-md-12 col-lg-12 col-sm-12 col-12">
                            <label class="m-t-5 font-weight-600"> Retirement benefits liabilities in respect of current members</label>
                          </div>
                          <div class="col-xxl-8 col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                            <div class="row">
                              <div [ngClass]="commonService.showControl? 'col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6':'col-xxl-9 col-xl-10 col-lg-10 col-md-11 col-sm-12 col-12'">
                                <div class="input-group mb-3">
                                  <div class="input-group-text">
                                    <span class=" theme-color font-weight-600">£</span>
                                  </div>
                                  <input type="text" class="form-control text-end AccountNumber" [appTooltip]="showBubbledata" appNumberdirective placeholder="" formControlName="AmountAnyExpectedReimbursementForProvision" (blur)="Calculations()" />
                                </div>
                              </div>
                              <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6" *ngIf="commonService.showControl==true">
                                <div class="input-group mb-3">
                                  <div class="input-group-text">
                                    <span class=" theme-color font-weight-600">£</span>
                                  </div>
                                  <input type="text" class="form-control text-end AccountNumber" [appTooltip]="showBubbledata" appNumberdirective placeholder="" formControlName="AmountAnyExpectedReimbursementForProvision_LY" (blur)="Calculations()" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                        <div class="row">
                          <div class="col-xxl-4 col-xl-4 col-md-12 col-lg-12 col-sm-12 col-12">
                            <label class="m-t-5 font-weight-600"> Amounts due to members in respect of profits</label>
                          </div>
                          <div class="col-xxl-8 col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                            <div class="row">
                              <div [ngClass]="commonService.showControl? 'col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6':'col-xxl-9 col-xl-10 col-lg-10 col-md-11 col-sm-12 col-12'">
                                <div class="input-group mb-3">
                                  <div class="input-group-text">
                                    <span class=" theme-color font-weight-600">£</span>
                                  </div>
                                  <input type="text" class="form-control text-end AccountNumber" [appTooltip]="showBubbledata" appNumberdirective placeholder="" formControlName="AmountsOwedToRelatedParties" (blur)="Calculations()" />
                                </div>
                              </div>
                              <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6" *ngIf="commonService.showControl==true">
                                <div class="input-group mb-3">
                                  <div class="input-group-text">
                                    <span class=" theme-color font-weight-600">£</span>
                                  </div>
                                  <input type="text" class="form-control text-end AccountNumber" [appTooltip]="showBubbledata" appNumberdirective placeholder="" formControlName="AmountsOwedToRelatedParties_LY" (blur)="Calculations()" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                        <div class="row">
                          <div class="col-xxl-4 col-xl-4 col-md-12 col-lg-12 col-sm-12 col-12">
                            <label class="m-t-5 font-weight-600"> Total</label>
                          </div>
                          <div class="col-xxl-8 col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                            <div class="row">
                              <div [ngClass]="commonService.showControl? 'col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6':'col-xxl-9 col-xl-10 col-lg-10 col-md-11 col-sm-12 col-12'">
                                <div class="input-group mb-3">
                                  <div class="input-group-text">
                                    <span class=" theme-color font-weight-600">£</span>
                                  </div>
                                  <input type="text" class="form-control text-end AccountNumber" [appTooltip]="showBubbledata" appNumberdirective placeholder="" formControlName="AmountsOwedToDirectors" />
                                </div>
                              </div>
                              <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6" *ngIf="commonService.showControl==true">
                                <div class="input-group mb-3">
                                  <div class="input-group-text">
                                    <span class=" theme-color font-weight-600">£</span>
                                  </div>
                                  <input type="text" class="form-control text-end AccountNumber" [appTooltip]="showBubbledata" appNumberdirective placeholder="" formControlName="AmountsOwedToDirectors_LY" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
              </div>
            </form>
          </div>

        </div>

        <div class="row">
          <div class="col-12 text-end">
            <button type="button" class="btn btn btn-outline-back p-1 ps-3 pe-3 me-2" (click)="On_Back()">Back</button>
            <button type="button" class="btn themedefault p-1 ps-3 pe-3 ms-1 me-0" (click)="On_Next()">Next</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
